import { SELECTED_TICKET_PREFIX } from './constants';

export function isSerializedActivity(product: string): boolean {
  return product.startsWith(`${SELECTED_TICKET_PREFIX}`);
}
